import { UIIcon } from '../config/icons';
import { ABScreen } from '../lib/ab/screen';
import { makeDateCorner } from '../lib/ab/widgets-home';
import { aTrackPage } from '../lib/mdl/a-track';
import { cBookingIsPastForSession, cBookingPartChangeQuantity, cBookingPartConfirm, CBookingPartId, cBookingPartReject, cBookingPartUnbook, cBookingRate } from '../lib/mdl/c-booking';
import { CBookingHomeView, cBookingPartGetUnbookInfo, cBookingPartInfoView, cBookingsFilterActive, cBookingsFilterPast, cBookingsFilterStandby, cBookingsHomeView, cBookingsSortActive, cBookingsSortPast, cBookingsSortStandby, cBookingsStandby, chBookingEventUrl, CHBookingList, chBookingList, chBookingListFilterActive, chBookingListFilterPast, chBookingListFilterStandby, chBookingListSortActive, chBookingListSortPast, chBookingListSortStandby } from '../lib/mdl/c-booking-home';
import { CTicketType } from '../lib/mdl/c-producer';
import { cUserFullName } from '../lib/mdl/c-user';
import { c_venues, cVenueGoogleMaps, CVenueSceneView, cVenueStaticMap } from '../lib/mdl/c-venue';
import { the_links } from '../lib/mdl/f-links';
import { TTicketHomeView } from '../lib/mdl/t-ticket';
import { LegacyEvent, legacyEventByID, LegacyEventSession, legacyPrettySessionTime } from '../lib/mdl/zzz-legacy-open-events';
import { the_user } from '../lib/me/login';
import { UIDataAdapter } from '../lib/ui/component/adapter';
import { UIButton } from '../lib/ui/component/button';
import { UIImageView } from '../lib/ui/component/image';
import { UIList } from '../lib/ui/component/list';
import { addTooltip } from '../lib/ui/component/tooltip';
import { showWarning } from '../lib/ui/component/warning';
import { $composer } from '../lib/ui/composer';
import { $el } from '../lib/ui/elements';
import { uiAddRipple } from '../lib/ui/ripple';
import { uiSetTransition } from '../lib/ui/transition';
import { UIRelPos } from '../lib/ui/types';
import { UIView, UIViewSpec } from '../lib/ui/view';
import { $analytics } from '../lib/y/analytics';
import { $i18n, yGetI18N, yInterpolate } from '../lib/y/i18n';
import { $location } from '../lib/y/location';
import { $time } from '../lib/y/time';
import { $id, YObjectId } from '../lib/y/types';
import { HomeBookDialog, HomeConfirmationDialog, homeDisplayCantBookMessage, newHomeDisplayCantBookMessage } from './event';
import { HomeReviewEventDialog } from './inbox';
import { HomeMenu } from './menu';

const tz = 'Europe/Stockholm';

class BookingCard extends UIView {
    constructor(booking: CBookingHomeView) {
        super('div', 'tl-booking-card');

        legacyEventByID($id.idToObjectId(booking.event_id)).then(event => {
            const session = event.getAnySession($id.idToObjectId(booking.session_id));
            if(!session) return;
            const venue = c_venues.maybe($id.objectIdToId(event.model.venue as YObjectId))!;

            const is_past = cBookingIsPastForSession(session);
            const status = booking.status;

            const title = $el.DIV('r-event', event.name);
            const texts = $el.DIV('r-texts', [
                title,
                $el.DIV('r-info', [$i18n.tl.booking_starts + ' ', $el.SPAN('t-w-bold', session.time_y.formatIn('HH:mm', tz))]),
                $el.DIV('r-venue', [$el.ICON(UIIcon.LOCATION_DOT), venue.name])
            ])

            const content = $el.DIV('r-content', [
                texts
            ]);

            if(is_past) {
                let shown = false;
                const rate = (r: 'up' | 'down') => {
                    if(booking.rating == r) return;
                    cBookingRate(booking.id, r);
                    thumb_up.classList.toggle('m-hollow', r == 'down');
                    thumb_down.classList.toggle('m-hollow', r == 'up');
                    if(!shown) {
                        add_comment.ui_show('fade-in');
                        shown = true;
                    }
                }

                const thumb_up = new UIButton({ kind: 'k-square', classes: 'm-round m-hollow ui-tint-reverse', icon: UIIcon.THUMBS_UP, on_click: () => { rate('up') } });
                const thumb_down = new UIButton({ kind: 'k-square', classes: 'm-round m-hollow ui-tint-reverse', icon: UIIcon.THUMBS_DOWN, on_click: () => { rate('down') } });

                if(booking.rating == 'up')
                    thumb_up.classList.remove('m-hollow');
                else if(booking.rating == 'down')
                    thumb_down.classList.remove('m-hollow');

                const add_comment = new UIButton({
                    title: $i18n.tl.b_leave_comment, kind: 'k-text', classes: 'm-inline ui-tint-reverse', on_click: () => {
                        new HomeReviewEventDialog(booking.id, undefined, event.model.pictures![0]).present();
                    }
                });
                add_comment.ui_hide();
                content.ui_add($el.DIV('r-thumbs', [thumb_up, thumb_down, add_comment]));
            }

            const image = new UIImageView({ media: event.model.pictures?.[0], variant: 'size-500' });
            const date_corner = makeDateCorner(session.time_y, is_past ? 'm-pink-reverse' : 'm-pink');

            const box = $el.DIV('r-box', [
                image,
                date_corner,
                content
            ]);

            this.ui_add(box);

            if(status != 'standby' && status != 'standby_reserved' && status == 'reserved' && !is_past && the_user!.recurring_status == 'pastdue') {
                const banner = $el.DIV('r-banner', $i18n.tl.t_pastdue_unbook_warning);
                this.ui_add(banner);
                banner.addEventListener('click', () => {
                    $location.navigate(['membership']);
                });
            }

            if(status == 'confirmed' && !is_past) {
                box.classList.add('u-clickable', 'tl-hover-zoom');
                this.root.addEventListener('click', () => {
                    $location.navigate(['booking', booking.part_id]);
                });

                uiAddRipple(box);
            } else {
                const handler = () => {
                    uiSetTransition('event-image', image, 'src');
                    uiSetTransition('event-info', texts, 'src');
                    uiSetTransition('booking-date', date_corner, 'src');
                    $location.navigate(event.screen_location);
                }

                image.classList.add('u-clickable');
                image.ui_elem.addEventListener('click', handler);
                title.classList.add('u-clickable');
                title.addEventListener('click', handler);
            }

            if($composer.current_transition?.event_id == $id.objectIdToId(event.model.id)) {
                uiSetTransition('event-image', image, 'dst');
                uiSetTransition('event-info', texts, 'dst');
                uiSetTransition('booking-date', date_corner, 'dst');
                this.classList.add('f-with-transition');
            }

            if(status == 'standby') {
                this.ui_add([
                    $el.DIV('r-info', $i18n.tl.standby_open_until + ' ' + event.getBookingEnd(session).formatIn('dd MMM HH:mm', tz)),
                    new UIButton({
                        kind: 'k-text', classes: 'm-inline ui-tint-reverse', title: $i18n.tl.b_standby_remove, on_click: () => {
                            cBookingPartUnbook(booking.part_id).then($location.reload);
                        }
                    })
                ])
            } else if(status == 'standby_reserved' || status == 'reserved') {
                const info = $el.ICON(UIIcon.CIRCLE_INFO | UIIcon.WEIGHT_SOLID);
                addTooltip($i18n.tl.tt_accept_latest + ' ' + $time(booking.expires_at).formatIn('EEE d MMM HH:mm', tz), this,
                    { offset: 8, hover: info, anchor: info, position: UIRelPos.Above });

                this.ui_add([
                    $el.DIV('r-info', [$i18n.tl.t_have_reservation + ' ', info]),
                    $el.DIV('r-buttons', [
                        new UIButton({
                            title: $i18n.tl.b_accept, classes: 'ui-tint-reverse', on_click: () =>
                                cBookingPartConfirm(booking.part_id).then(() => {
                                    $location.reload();
                                    new HomeConfirmationDialog(booking, event, venue, session, 'bookings').present();
                                }, reason => {
                                    return homeDisplayCantBookMessage(reason, event.model.id);
                                })
                        }),
                        new UIButton({
                            title: $i18n.tl.b_decline, classes: 'ui-tint-reverse m-hollow', on_click: () => {
                                showWarning({ text: $i18n.tl.t_decline_confirmation, cancel_text: $i18n.tl.b_cancel, ok_text: $i18n.tl.b_confirm }).then(() => {
                                    cBookingPartReject(booking.part_id).then(() => {
                                        $location.reload();
                                    });
                                });
                            }
                        })
                    ])
                ]);
            }
        });

    }
}

function makeTicket(booking: CBookingHomeView, event: LegacyEvent, session: LegacyEventSession, venue: CVenueSceneView, ticket_type: CTicketType, ticket?: TTicketHomeView) {
    const user = the_user!;
    const scene = event.model.show_scene && venue.scenes.find(v => v.id == $id.objectIdToId(event.model.scene as YObjectId));

    const box = $el.DIV('r-box');
    const image = $el.DIV('r-image', [$el.DIV('r-left-circle'), $el.DIV('r-right-circle')]);

    if(ticket_type == 'pickup') {
        box.ui_add([
            $el.DIV('r-row', [$el.I($i18n.tl.t_ticket_guestlist), $el.I(user.first_name)]),
            $el.DIV('r-row', [$el.I(yInterpolate(booking.quantity == 1 ? $i18n.tl.t_ticket_person : $i18n.tl.t_ticket_people, booking.quantity)), $el.I(user.last_name)])
        ])
    } else if(ticket) {
        if(ticket.type == 'pdf') {
            box.ui_add($el.DIV('r-row', [
                $el.I($i18n.tl.b_ticket_pdf),
                new UIButton({ icon: UIIcon.ARROW_RIGHT, kind: 'k-square', classes: 'm-round c-dark', link: '/docs/tickets/' + booking.id + '/' + booking.token })
            ]));
        } else {
            box.ui_add([
                $el.DIV('r-row', [$el.I(ticket.seat.entrance), $el.I(yInterpolate($i18n.tl.t_ticket_row, ticket.seat.display_row))]),
                $el.DIV('r-row', [$el.I(ticket.seat.section), $el.I(yInterpolate($i18n.tl.t_ticket_seat, ticket.seat.display_seat))])
            ])
        }
    } else {
        box.ui_add(yInterpolate($i18n.tl.t_ticket_activates, session.time_y.add(-3, $time.hour).format("d MMM, HH:mm")));
    }

    if(ticket?.type == 'code') {
        image.ui_add(new UIImageView({ url: `/assets/booking/${booking.id}/${booking.token}/ticket/${ticket.id}`, size: 'contain' }, { classes: 'r-qr' }))
    } else {
        image.ui_add($el.DIV('r-logo'));
    }

    return $el.DIV('tl-ticket', [
        $el.DIV('r-title', event.name),
        image,
        $el.DIV('r-venue', venue.name),
        scene && $el.DIV('r-scene', scene.name),
        $el.DIV('r-time', legacyPrettySessionTime(session, 'MMM')),
        box,
        $el.DIV('r-info', $i18n.tl.t_ticket_booking + ' ' + booking.number),
        $el.DIV('r-logo'),
        $el.DIV('r-bottom', yInterpolate($i18n.tl.t_ticket_personal, cUserFullName(user))),
        booking.has_purchases && $el.DIV('r-bottom t-underline', $i18n.tl.t_ticket_nonrefundable),
    ]);

}

export class HomeBookingScreen extends ABScreen {
    constructor(private _id: CBookingPartId) {
        super({ menu: new HomeMenu({ classes: 'm-account' }) });
    }

    protected override async fillContent(content: UIViewSpec) {
        const [booking, event, venue, availability, ticket_type, tickets] = await cBookingPartInfoView(this._id);

        const session = event.getSession($id.idToObjectId(booking.session_id))!;

        const map_url = cVenueStaticMap(venue);

        const action_buttons = $el.DIV('l-button-row m-left-d b');

        const instructions = yGetI18N(availability.instructions).split('\n').map(s => s.trim()).filter(s => s);
        const event_name = $el.H2('title', event.name, 'u-clickable p-a-left q-td');
        event_name.addEventListener('click', () => {
            $location.navigate(event.screen_location);
        });

        const makeTickets = () => {
            if(ticket_type == 'email' && tickets[0]?.type == 'code') {
                return tickets.map(t => makeTicket(booking, event, session, venue, ticket_type, t));
            } else {
                return makeTicket(booking, event, session, venue, ticket_type, tickets[0]);
            }
        }

        content.ui_add($el.SECTION('l-columns w-block-td', [
            $el.DIV('i-column m-540 l-form tl-booking-column w-block-m', [
                event_name,
                $el.DIV('tl-time-or-place q-td', [$el.ICON(UIIcon.CLOCK | UIIcon.WEIGHT_SOLID), legacyPrettySessionTime(session, 'MMMM')]),
                $el.DIV('tl-time-or-place q-td', [$el.ICON(UIIcon.LOCATION_DOT | UIIcon.WEIGHT_SOLID), venue.name]),
                $el.DIV('s-tiny'),
                action_buttons,
                $el.DIV('tl-tickets b q-t', makeTickets()),
                $el.DIV('s-small'),
                $el.H3('heading', $i18n.tl.t_booking_instructions),
                $el.Ps('text', instructions),
                map_url && $el.A(cVenueGoogleMaps(venue), [$el.IMG(map_url, undefined, venue.name), $el.DIV('r-icon'), $el.DIV('r-venue', [$el.DIV('r-name', venue.name), $el.DIV('r-address', venue.address)])], 'tl-static-map b')
            ]),
            $el.DIV('tl-ticket-column', [
                $el.P('text', yInterpolate(booking.quantity == 1 ? $i18n.tl.t_booking_amount_1 : $i18n.tl.t_booking_amount_n, booking.quantity)),
                $el.DIV('tl-tickets', makeTickets())
            ])
        ]));

        if(availability.max_book_free > 0) {
            action_buttons.ui_add(new UIButton({
                title: $i18n.tl.b_add_ticket, classes: 'ui-tint-reverse', on_click: () =>
                    cBookingPartChangeQuantity(booking.part_id, booking.quantity + 1).then($location.reload)
            }))
        } else if(availability.max_standby > 0) {
            action_buttons.ui_add(new UIButton({
                title: $i18n.tl.b_add_standby, classes: 'ui-tint-reverse', on_click: () =>
                    cBookingsStandby(booking.session_id, 1, booking.id).then(() => {
                        $location.reload();
                    })
            }))
        } else if(availability.max_book > 0) {
            action_buttons.ui_add(new UIButton({
                title: $i18n.tl.b_buy_more, classes: 'ui-tint-reverse', on_click: () =>
                    new HomeBookDialog(event, venue, session, 'bookings', availability, booking).present().then(() => {
                        $location.reload();
                    })
            }))
        }

        if(booking.quantity > 1 && booking.base_quantity > 0) {
            action_buttons.ui_add(new UIButton({
                title: $i18n.tl.b_unbook_one, classes: 'ui-tint-reverse', on_click: () =>
                    cBookingPartGetUnbookInfo(booking.part_id).then(info => {
                        if(info.is_late) {
                            showWarning({
                                text: $i18n.tl.w_late_unbook,
                                cancel_text: $i18n.tl.b_cancel, ok_text: $i18n.tl.b_ok, link_text: $i18n.tl.b_read_more, link_link: the_links.unbooking
                            }).then(() => {
                                cBookingPartChangeQuantity(booking.part_id, booking.quantity - 1, true).then($location.reload);
                            });
                        } else {
                            showWarning({ text: $i18n.tl.w_unbook_one, cancel_text: $i18n.tl.b_cancel, ok_text: $i18n.tl.b_confirm }).then(() => {
                                cBookingPartChangeQuantity(booking.part_id, booking.quantity - 1).then($location.reload);
                            });
                        }
                    })
            }))
        }

        if(!booking.has_purchases) {
            action_buttons.ui_add(new UIButton({
                title: $i18n.tl.b_unbook, classes: 'm-hollow ui-tint-reverse', on_click: () =>
                    cBookingPartGetUnbookInfo(booking.part_id).then(info => {
                        $analytics.track('Click cancel ticket');
                        if(info.is_late) {
                            showWarning({
                                text: $i18n.tl.w_late_unbook,
                                cancel_text: $i18n.tl.b_cancel, ok_text: $i18n.tl.b_ok, link_text: $i18n.tl.b_read_more,
                                link_link: the_links.unbooking
                            }).then(() => {
                                cBookingPartUnbook(booking.part_id, true).then(() => {
                                    $location.navigate(['bookings']);
                                });
                            });
                        } else {
                            showWarning({ text: $i18n.tl.w_unbook, cancel_text: $i18n.tl.b_cancel, ok_text: $i18n.tl.b_confirm }).then(() => {
                                cBookingPartUnbook(booking.part_id).then(() => {
                                    $location.navigate(['bookings']);
                                });
                            });
                        }
                    })
            }));
        }

        aTrackPage('booking', { booking: booking.id, event: $id.objectIdToId(event.model.id) });
    }
}

export class HomeBookingsScreen extends ABScreen {
    constructor() {
        super({ menu: new HomeMenu({ classes: 'm-account' }) });
    }

    protected override async fillContent(content: UIViewSpec) {
        const all_bookings = await cBookingsHomeView(true);

        const active: CBookingHomeView[] = [];
        const standby: CBookingHomeView[] = [];
        const past: CBookingHomeView[] = [];

        for(const b of all_bookings) {
            if(cBookingsFilterActive(b))
                active.push(b);
            else if(cBookingsFilterStandby(b))
                standby.push(b);
            else if(cBookingsFilterPast(b))
                past.push(b);
        }

        let empty_view: HTMLElement | undefined;
        const active_section = new UIDataAdapter((b: CBookingHomeView) => new BookingCard(b));
        active_section.header = $el.DIV('r-header', [$el.ICON(UIIcon.ARROW_DOWN), $i18n.tl.h_bookings_current]);
        const standby_section = new UIDataAdapter((b: CBookingHomeView) => new BookingCard(b));
        standby_section.header = $el.DIV('r-header', [$el.ICON(UIIcon.ARROW_DOWN), $i18n.tl.h_bookings_standby]);
        const past_section = new UIDataAdapter((b: CBookingHomeView) => new BookingCard(b));
        past_section.header = $el.DIV('r-header', [$el.ICON(UIIcon.ARROW_DOWN), $i18n.tl.h_bookings_past]);

        const section = $el.DIV('ui-section', [
            $el.DIV('w-block', $el.P('title', $i18n.tl.h_bookings)),
            new UIList([active_section, standby_section, past_section], { classes: 'tl-booking-list', progressive: true })
        ]);

        content.ui_add([
            section
        ]);

        if(empty_view) {
            empty_view.remove();
            empty_view = undefined;
        }


        active.sort(cBookingsSortActive);
        standby.sort(cBookingsSortStandby);
        past.sort(cBookingsSortPast);

        active_section.data = active;
        standby_section.data = standby;
        past_section.data = past;

        if(!active.length && !standby.length && !past.length) {
            // TODO
            // this.content.ui_add(empty_view = $el.DIV('tl-empty', [
            //     $el.P('title', $i18n.tl.e_bookings),
            //     new UIButton({ kind: 'k-text', title: $i18n.tl.b_all_events, on_click: () => { $location.navigate([]) }})
            // ]));
        }

        aTrackPage('bookings');
    }
}

class NewBookingCard extends UIView {
    constructor(booking: CHBookingList) {
        super('div', 'tl-booking-card');

        const is_past = $time(booking.inactive_at).is_past;
        const status = booking.status;

        const title = $el.DIV('r-event', yGetI18N(booking.event_name));
        const texts = $el.DIV('r-texts', [
            title,
            $el.DIV('r-info', [$i18n.tl.booking_starts + ' ', $el.SPAN('t-w-bold', $time(booking.session_time).formatIn('HH:mm', tz))]),
            $el.DIV('r-venue', [$el.ICON(UIIcon.LOCATION_DOT), booking.venue_name])
        ])

        const content = $el.DIV('r-content', [
            texts
        ]);

        if(is_past) {
            let shown = false;
            const rate = (r: 'up' | 'down') => {
                if(booking.rating == r) return;
                cBookingRate(booking.id, r);
                thumb_up.classList.toggle('m-hollow', r == 'down');
                thumb_down.classList.toggle('m-hollow', r == 'up');
                if(!shown) {
                    add_comment.ui_show('fade-in');
                    shown = true;
                }
            }

            const thumb_up = new UIButton({ kind: 'k-square', classes: 'm-round m-hollow ui-tint-reverse', icon: UIIcon.THUMBS_UP, on_click: () => { rate('up') } });
            const thumb_down = new UIButton({ kind: 'k-square', classes: 'm-round m-hollow ui-tint-reverse', icon: UIIcon.THUMBS_DOWN, on_click: () => { rate('down') } });

            if(booking.rating == 'up')
                thumb_up.classList.remove('m-hollow');
            else if(booking.rating == 'down')
                thumb_down.classList.remove('m-hollow');

            const add_comment = new UIButton({
                title: $i18n.tl.b_leave_comment, kind: 'k-text', classes: 'm-inline ui-tint-reverse', on_click: () => {
                    new HomeReviewEventDialog(booking.id, undefined, booking.picture_id).present();
                }
            });
            add_comment.ui_hide();
            content.ui_add($el.DIV('r-thumbs', [thumb_up, thumb_down, add_comment]));
        }

        const image = new UIImageView({ media: booking.picture_id, variant: 'size-500' });
        const date_corner = makeDateCorner($time(booking.session_time), is_past ? 'm-pink-reverse' : 'm-pink');

        const box = $el.DIV('r-box', [
            image,
            date_corner,
            content
        ]);

        this.ui_add(box);

        if(status != 'standby' && status != 'standby_reserved' && status == 'reserved' && !is_past && the_user!.recurring_status == 'pastdue') {
            const banner = $el.DIV('r-banner', $i18n.tl.t_pastdue_unbook_warning);
            this.ui_add(banner);
            banner.addEventListener('click', () => {
                $location.navigate(['membership']);
            });
        }

        if(status == 'confirmed' && !is_past) {
            box.classList.add('u-clickable', 'tl-hover-zoom');
            this.root.addEventListener('click', () => {
                $location.navigate(['booking', booking.part_id]);
            });

            uiAddRipple(box);
        } else {
            const handler = () => {
                uiSetTransition('event-image', image, 'src');
                uiSetTransition('event-info', texts, 'src');
                uiSetTransition('booking-date', date_corner, 'src');
                $location.navigate(chBookingEventUrl(booking));
            }

            image.classList.add('u-clickable');
            image.ui_elem.addEventListener('click', handler);
            title.classList.add('u-clickable');
            title.addEventListener('click', handler);
        }

        if($composer.current_transition?.event_id == booking.event_id) {
            uiSetTransition('event-image', image, 'dst');
            uiSetTransition('event-info', texts, 'dst');
            uiSetTransition('booking-date', date_corner, 'dst');
            this.classList.add('f-with-transition');
        }

        if(status == 'standby') {
            this.ui_add([
                $el.DIV('r-info', $i18n.tl.standby_open_until + ' ' + $time(booking.sales_end_at).formatIn('dd MMM HH:mm', tz)),
                new UIButton({
                    kind: 'k-text', classes: 'm-inline ui-tint-reverse', title: $i18n.tl.b_standby_remove, on_click: () => {
                        cBookingPartUnbook(booking.part_id).then($location.reload);
                    }
                })
            ])
        } else if(status == 'standby_reserved' || status == 'reserved') {
            const info = $el.ICON(UIIcon.CIRCLE_INFO | UIIcon.WEIGHT_SOLID);
            addTooltip($i18n.tl.tt_accept_latest + ' ' + $time(booking.expires_at).formatIn('EEE d MMM HH:mm', tz), this,
                { offset: 8, hover: info, anchor: info, position: UIRelPos.Above });

            this.ui_add([
                $el.DIV('r-info', [$i18n.tl.t_have_reservation + ' ', info]),
                $el.DIV('r-buttons', [
                    new UIButton({
                        title: $i18n.tl.b_accept, classes: 'ui-tint-reverse', on_click: () =>
                            cBookingPartConfirm(booking.part_id).then(() => {
                                $location.reload();
                                // new NewHomeConfirmationDialog(booking, event, venue, session, 'bookings').present();
                            }, reason => {
                                return newHomeDisplayCantBookMessage(reason);//, event.model.id);
                            })
                    }),
                    new UIButton({
                        title: $i18n.tl.b_decline, classes: 'ui-tint-reverse m-hollow', on_click: () => {
                            showWarning({ text: $i18n.tl.t_decline_confirmation, cancel_text: $i18n.tl.b_cancel, ok_text: $i18n.tl.b_confirm }).then(() => {
                                cBookingPartReject(booking.part_id).then(() => {
                                    $location.reload();
                                });
                            });
                        }
                    })
                ])
            ]);
        }
    }
}

export class HomeNewBookingsScreen extends ABScreen {
    constructor() {
        super({ menu: new HomeMenu({ classes: 'm-account' }) });
    }

    protected override async fillContent(content: UIViewSpec) {
        const all_bookings = await chBookingList(true);

        const active: CHBookingList[] = [];
        const standby: CHBookingList[] = [];
        const past: CHBookingList[] = [];

        for(const b of all_bookings) {
            if(chBookingListFilterActive(b))
                active.push(b);
            else if(chBookingListFilterStandby(b))
                standby.push(b);
            else if(chBookingListFilterPast(b))
                past.push(b);
        }

        let empty_view: HTMLElement | undefined;
        const active_section = new UIDataAdapter((b: CHBookingList) => new NewBookingCard(b));
        active_section.header = $el.DIV('r-header', [$el.ICON(UIIcon.ARROW_DOWN), $i18n.tl.h_bookings_current]);
        const standby_section = new UIDataAdapter((b: CHBookingList) => new NewBookingCard(b));
        standby_section.header = $el.DIV('r-header', [$el.ICON(UIIcon.ARROW_DOWN), $i18n.tl.h_bookings_standby]);
        const past_section = new UIDataAdapter((b: CHBookingList) => new NewBookingCard(b));
        past_section.header = $el.DIV('r-header', [$el.ICON(UIIcon.ARROW_DOWN), $i18n.tl.h_bookings_past]);

        const section = $el.DIV('ui-section', [
            $el.DIV('w-block', $el.P('title', $i18n.tl.h_bookings)),
            new UIList([active_section, standby_section, past_section], { classes: 'tl-booking-list', progressive: true })
        ]);

        content.ui_add([
            section
        ]);

        if(empty_view) {
            empty_view.remove();
            empty_view = undefined;
        }


        active.sort(chBookingListSortActive);
        standby.sort(chBookingListSortStandby);
        past.sort(chBookingListSortPast);

        active_section.data = active;
        standby_section.data = standby;
        past_section.data = past;

        if(!active.length && !standby.length && !past.length) {
            // TODO
            // this.content.ui_add(empty_view = $el.DIV('tl-empty', [
            //     $el.P('title', $i18n.tl.e_bookings),
            //     new UIButton({ kind: 'k-text', title: $i18n.tl.b_all_events, on_click: () => { $location.navigate([]) }})
            // ]));
        }

        aTrackPage('bookings');
    }
}
